import React from 'react';
import ReactDOM from 'react-dom/client';

import UserProfile from './UserProfile';

const root = ReactDOM.createRoot(document.getElementById('user_profile'));

root.render(
  <React.StrictMode>
    <UserProfile />
  </React.StrictMode>
);
